


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const cancelQuotationReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.CANCEL_QUOTATION_CASES:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.CANCEL_QUOTATION_CASES_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.CANCEL_QUOTATION_CASES_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
